import {
  POST,
  GET
} from '@/axios/axios'

export const services = {
  AgentsList: (param) => { // 代理商列表
    return GET("/backend/custom/queryAgentByPage", param);
  },
  AgentsInsert: (param) => { // 新增/编辑代理商
    return POST("/backend/custom/saveAgent?version=v2", param);
  },
  findAgentCheck: (param) => { // 代理商待审核列表
    return GET("/backend/custom/findAgentCheckList", param);
  },
  updateAgentCheck: (param) => { // 代理商审核
    return POST("/backend/custom/updateAgentCheck", param);
  },
  associationAgent: (param) => { // 代理商关联父级代理商
    return POST("/backend/agentMerchantRel/associationAgent", param);
  },
  agentByStatus: (param) => { // 获取可作为父级代理商信息
    return GET("/backend/custom/findAgentByStatus", param);
  },
  updateAgent: (param) => { // 代理商关联解绑
    return POST("/backend/agentMerchantRel/updateAssociationAgent", param);
  },
  findAssociatAgent: (param) => { // 代理商关联代理商列表接口
    return GET("/backend/agentMerchantRel/findAssociationAgent", param);
  },
  insertSettleRule: (param) => { // 增加代理商分润规则设置
    return POST("/backend/customExtra/insertSettleRule", param);
  },
  selectAgentById: (param) => { // 根据代理商id查询基础点数
    return GET("/backend/custom/findAgentById", param);
  }
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/facilitator.js